import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ClientDownload } from '../../models/download/client-download.model';
import { PatchDownload } from '../../models/download/patch-download.model';
import { Pageable } from '../../models/common/pageable.model';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  private readonly baseUrl = `${environment.backend.url}/api/download/v1`;

  constructor(private readonly http: HttpClient) { }

  /**
   * Gets the latest client download information
   * @returns An Observable with ClientDownload information
   */
  public getLatestClient(): Observable<ClientDownload> {
    return this.http.get<ClientDownload>(`${this.baseUrl}/latest-client`);
  }

  /**
   * Gets a paginated list of patches
   * @param page The page number (0-based)
   * @param ipp Items per page
   * @returns An Observable with a paginated list of PatchDownload objects
   */
  public getPatches(page: number = 0, ipp: number = 25): Observable<Pageable<PatchDownload>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('ipp', ipp.toString());

    return this.http.get<Pageable<PatchDownload>>(`${this.baseUrl}/patches`, { params });
  }
}
